import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { useAnalytics } from '../hooks/useAnalytics';
type Offer = {
  id: string;
  title: string;
  description: string;
  price: string;
  savings?: string;
  isPopular?: boolean;
  link: string;
};
const offers: Offer[] = [{
  id: 'best',
  title: 'Treatment Plan (5 Bottles)',
  description: 'Recommended for chronic stiffness. Buy 3, Get 2 Free.',
  price: '$89.97',
  savings: 'Save $60.00',
  isPopular: true,
  link: 'https://www.ginextwarming.com/cart/45467602845882:1'
}, {
  id: 'popular',
  title: 'Standard Course (3 Bottles)',
  description: 'Ideal for recurring tension. Buy 2, Get 1 Free.',
  price: '$59.98',
  savings: 'Save $30.00',
  link: 'https://www.ginextwarming.com/cart/45467602124986:1'
}, {
  id: 'starter',
  title: 'Trial Size (1 Bottle)',
  description: 'For acute, short-term relief.',
  price: '$29.99',
  link: 'https://www.ginextwarming.com/cart/45467601207482:1'
}];
export function TextOfferSection() {
  const [selected, setSelected] = useState<string>('best');
  const {
    trackClick
  } = useAnalytics();
  return <div className="my-12 p-6 sm:p-8 bg-stone-50 border border-stone-200 rounded-sm" id="offers" data-id="element-1350">
      <h3 className="font-serif text-2xl text-stone-900 mb-2" data-id="element-1351">
        Availability Update
      </h3>
      <p className="font-serif text-stone-600 mb-6 italic text-sm" data-id="element-1352">
        Due to high demand, inventory is limited. Current stock status:{' '}
        <span className="text-green-700 font-semibold not-italic" data-id="element-1353">
          Available
        </span>
      </p>

      <div className="space-y-4" data-id="element-1354">
        {offers.map(offer => <a key={offer.id} href={offer.link} className={`block p-4 border transition-all duration-200 no-underline group ${selected === offer.id ? 'border-stone-800 bg-white shadow-sm' : 'border-stone-200 hover:border-stone-400 bg-transparent'}`} onClick={e => {
        // Track click before navigation
        trackClick({
          offer: offer.title,
          price: offer.price
        });
        setSelected(offer.id);
      }} onMouseEnter={() => setSelected(offer.id)} data-id="element-1355">
            <div className="flex items-start justify-between gap-4" data-id="element-1356">
              <div className="flex-1" data-id="element-1357">
                <div className="flex items-center gap-2 mb-1" data-id="element-1358">
                  <h4 className={`font-serif text-lg font-medium ${selected === offer.id ? 'text-stone-900' : 'text-stone-600'}`} data-id="element-1359">
                    {offer.title}
                  </h4>
                  {offer.isPopular && <span className="text-[10px] uppercase tracking-widest font-sans bg-stone-900 text-white px-2 py-0.5" data-id="element-1360">
                      Most Selected
                    </span>}
                </div>
                <p className="font-serif text-stone-500 text-sm leading-relaxed" data-id="element-1361">
                  {offer.description}
                </p>
                {offer.savings && <p className="font-sans text-xs text-stone-500 mt-1 font-medium" data-id="element-1362">
                    {offer.savings}
                  </p>}
              </div>
              <div className="text-right" data-id="element-1363">
                <span className="font-serif text-xl font-semibold text-stone-900 block" data-id="element-1364">
                  {offer.price}
                </span>
                <span className={`text-xs font-sans font-medium mt-2 inline-flex items-center gap-1 ${selected === offer.id ? 'text-stone-900' : 'text-stone-400 opacity-0 group-hover:opacity-100'}`} data-id="element-1365">
                  Select <Check className="w-3 h-3" data-id="element-1366" />
                </span>
              </div>
            </div>
          </a>)}
      </div>

      <div className="mt-6 pt-6 border-t border-stone-200 text-center" data-id="element-1367">
        <p className="font-serif text-sm text-stone-500 mb-4" data-id="element-1368">
          All options include a 30-day money-back guarantee.
        </p>
        <a href={offers.find(o => o.id === selected)?.link} onClick={() => trackClick({
        action: 'proceed_to_checkout',
        offer: selected
      })} className="inline-block bg-stone-900 text-white font-sans text-sm uppercase tracking-widest px-8 py-4 hover:bg-stone-800 transition-colors" data-id="element-1369">
          Proceed to Checkout
        </a>
      </div>
    </div>;
}